<template>
  <div :class="video_popup_class" @click="close_popup">
    <div class="option-bar" v-if="sub_popup == null">
      <span class="close-link" @click="try_to_close_popup">X</span>
    </div>
    <div
      class="popup_content_container w-full max-w-6xl mx-auto text-left relative"
      @click="prevent_close($event)"
    >
      <div v-if="sub_popup == null">
        <!--        <h1 class="text-main-color uppercase font-bold mb-8 text-center">-->
        <!--          {{ getCurrentSectionContent().title }}-->
        <!--        </h1>-->

        <ul :class="pdf_list_class">
          <li
            class=""
            v-for="(item, index) in getCurrentSectionContent().list"
            :key="'pdf_list_item_' + index"
          >
            <!-- internal links, should open a sub content in the popup -->
            <a
              class="block shadow-md"
              target="_blank"
              href="#"
              @click.prevent="show_internal_content(index)"
              v-if="
                'undefined' != typeof item.type &&
                item.type.indexOf('internal') >= 0
              "
              ><img
                v-if="'undefined' != typeof item.thumb"
                :src="
                  'static/content/' +
                  selected_section +
                  '/' +
                  selected_sub_section +
                  '/thumb/' +
                  item.thumb
                "
            /></a>
            <!-- for external links -->
            <a
              class="block px-4 py-2 bg-gray-100 rounded hover:bg-gray-200 shadow-md"
              target="_blank"
              :href="get_item_href(item)"
              v-ga="
                $ga.commands.trackExternalLink.bind(
                  get_this,
                  get_item_href(item)
                )
              "
              @click.prevent="show_external_content(index)"
              v-else
              ><img
                v-if="'undefined' != typeof item.thumb"
                :src="
                  'static/content/' +
                  selected_section +
                  '/' +
                  selected_sub_section +
                  '/thumb/' +
                  item.thumb
                "
              /><span>{{ item.title }}</span></a
            >
          </li>
        </ul>
      </div>
      <div class="pb-10" v-else>
        <!--        <div class="back-bar">-->
        <!--          <a href="#" class="back-link" @click.prevent="back_to_list">Back</a>-->
        <!--        </div>-->
        <!--        <h1 class="text-main-color uppercase font-bold mb-8 text-center">-->
        <!--          {{ sub_popup.title }}-->
        <!--        </h1>-->
        <internal_video
          v-if="sub_popup.type == 'internal_video'"
          :item="sub_popup"
        />
        <internal_vimeo
          v-if="sub_popup.type == 'internal_vimeo'"
          :item="sub_popup"
        />
        <internal_image
          v-else-if="sub_popup.type == 'internal_image'"
          :item="sub_popup"
        />
        <internal_audio
          v-else-if="sub_popup.type == 'internal_audio'"
          :item="sub_popup"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import internal_video from "./../subpopups/video";
import internal_vimeo from "./../subpopups/videoVimeo";
import internal_image from "./../subpopups/image";
import internal_audio from "./../subpopups/audioPopup";

export default {
  name: "VideoLinksPopup",
  components: {
    internal_video,
    internal_vimeo,
    internal_image,
    internal_audio
  },
  data() {
    return {
      loading: "",
      sub_popup: null
    };
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "current_secondary_section",
      "current_secondary_sub_section",
      "sections_content"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),

    page_url() {
      //var popup_title = this.getCurrentSectionContent().title;
      //var slug = popup_title.split(" ").join("-").toLowerCase();

      var str =
        "/" +
        this.eventTag +
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/link-list/";

      return str;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    video_popup_class() {
      return "popup " + this.loading;
    },
    pdf_list_class() {
      let str = "pdf-list";
      str += " flex";

      return str;
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    },
    get_this() {
      return this;
    }
  },
  methods: {
    get_item_href(item) {
      if ("undefined" == typeof item.type) {
        return (
          "static/content/" +
          this.selected_section +
          "/" +
          this.selected_sub_section +
          "/pdf/" +
          item.filename
        );
      } else {
        return item.filename;
      }
    },

    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    },
    try_to_close_popup(e) {
      if (this.sub_popup != null) {
        this.sub_popup = null;
      } else {
        this.close_popup(e);
      }
    },
    close_popup(e) {
      console.log("close popup");

      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_interactive_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_video_src, 10)
        );
      }

      this.$bus.$emit("send_interactive_msg", "popupClosed", 1);
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
    },
    prevent_close(e) {
      e.stopPropagation();
    },
    video_started() {
      this.loading = "";
    },

    show_internal_content(idx) {
      this.sub_popup = this.getCurrentSectionContent().list[idx];

      if (this.sub_popup.type == "internal_slideshow") {
        //internal_slideshow
        this.$ga.page(
          this.page_url +
            "content/" +
            (idx + 1) +
            "/" +
            this.sub_popup.type +
            "/" +
            this.sub_popup.title
        );
      } else {
        //internal_video
        //internal_vimeo
        //internal_image
        //internal_audio
        this.$ga.page(
          this.page_url +
            "content/" +
            (idx + 1) +
            "/" +
            this.sub_popup.type +
            "/?file=" +
            (this.sub_popup.filename || this.sub_popup.url)
        );
      }
    },
    show_external_content(idx) {
      var sub_info = this.getCurrentSectionContent().list[idx];
      this.$ga.page(
        this.page_url +
          "content/" +
          (idx + 1) +
          "/external_link/?file=" +
          sub_info.filename
      );
    },
    back_to_list() {
      this.sub_popup = null;
    }
  },
  mounted() {
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$bus.$on("request-subpopup-close", this.back_to_list);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    console.log("destroying video popup");
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 44, 107, 0.8);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  xjustify-content: center;
}
.popup_content_container {
  margin-top: auto;
  margin-bottom: auto;
  max-height: calc(var(--vh, 1vh) * 100);
}

.option-bar {
  position: absolute;
  top: 3vh;
  right: 2vh;
  width: 60px;
  height: 60px;
}
.close-link {
  color: #fff;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 60px;
  height: 60px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
  cursor: pointer;
}
.popup_video_container {
  align-self: center;
  margin: auto 0;
}

.app-popup-instructions {
  background: rgba(20, 20, 20, 0.8);
  text-transform: uppercase;
}
.pdf-list {
  width: 90%;
  max-width: 120vh;
  margin: 0 auto;
  flex-wrap: wrap;
}
.pdf-list img {
  display: inline-block;
}
.pdf-list li a {
  display: flex;
  align-content: center;
  align-items: center;
}
.pdf-list li {
  flex: 0 0 45%;
  margin-right: 2%;
  margin-left: 2%;
  margin-bottom: 30px;
}
.pdf-list li:first-child {
  xflex: 0 0 45%;
  xmargin-left: 25%;
}

.back-bar {
  position: absolute;
  top: 20px;
  left: 30px;

  color: #03344a;
}

.back-bar a {
  background: url("../../assets/icon-back.png") 0 0 no-repeat;
  background-size: contain;
  display: inline-block;
  height: 30px;
  padding-left: 40px;
  line-height: 30px;
}
.popup_content_container {
  transition: height 4s ease-out;
}
@media only screen and (max-width: 1110px),
  only screen and (max-height: 460px) {
  .close-link {
    width: 30px;
    height: 30px;
  }
}
@media only screen and (max-width: 710px) and (min-height: 650px) {
  .pdf-list {
    flex-flow: column;
    max-width: 300px;
  }
  .pdf-list li {
    flex: 0 0 100% !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>
<style>
.popup_video_container {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/VideoLinksPopup.vue